import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';

export interface TablePagerProps {
  /** Noldan boshlanadi. */
  page: number;
  pages: number;
  /** Ko'rsatilayotgan oraliq — 1 dan boshlab, odam o'qiydigan shaklda. */
  from: number;
  to: number;
  total: number;
  onChange: (page: number) => void;
}

/**
 * SAHIFALASH — 233 qator DOM da bir vaqtda turmasin.
 *
 * Virtualizatsiya kutubxonasi qo'shilmadi: har checkbox bosilganda 233
 * qator qayta chizilishi sezilardi, lekin bu muammoni 50 qatorlik
 * sahifa ham hal qiladi — yangi bog'liqliksiz va yopishqoq sarlavha
 * bilan birga ishlaydigan holda.
 *
 * Bitta sahifa bo'lsa umuman chizilmaydi: bo'sh boshqaruv ekranda joy
 * egallab, hech narsa aytmasdi.
 */
export const TablePager = ({ page, pages, from, to, total, onChange }: TablePagerProps) => {
  if (pages <= 1) return null;

  return (
    <nav
      aria-label={t('supply.linesCaption')}
      className="flex items-center justify-between gap-3 px-4 py-2.5"
    >
      <span className="tabular-nums text-xs text-text-muted">
        {t('supply.pageRange', { from, to, total })}
      </span>

      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="sm"
          disabled={page === 0}
          aria-label={t('supply.pagePrev')}
          title={t('supply.pagePrev')}
          onClick={() => onChange(page - 1)}
          className="px-2"
        >
          <ChevronLeft size={16} aria-hidden />
        </Button>

        <span className="tabular-nums px-2 text-xs font-medium text-text">
          {page + 1} / {pages}
        </span>

        <Button
          variant="ghost"
          size="sm"
          disabled={page >= pages - 1}
          aria-label={t('supply.pageNext')}
          title={t('supply.pageNext')}
          onClick={() => onChange(page + 1)}
          className="px-2"
        >
          <ChevronRight size={16} aria-hidden />
        </Button>
      </div>
    </nav>
  );
};
